<template>
  <v-container class="pa-0">
    <v-alert
      :icon="icon(notification.notificationType)"
      :type="notification.notificationType.toLowerCase()"
      dense
      v-for="notification in notifiables"
      :key="notification.id"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ notification.notificationText }}
        </v-col>
        <v-col
          class="shrink action"
          v-if="isNotApproved(notification) || paymentFailed(notification)"
        >
          <v-btn
            v-if="isNotApproved(notification)"
            depressed
            :to="redirectToPayForSubscription(notification)"
            >Make Payment Now</v-btn
          >
          <v-btn
            v-else
            @click="
              newPaymentSession();
              selectedNotification = notification;
            "
            depressed
            >Update Payment Now</v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>

<script>
import { userNotificationsAPI, userNotificationsByIdAPI } from "@/services/api";
import { get, put } from "@/services/request";
import hasNotifications from "@/mixins/has-notifications";

export default {
  name: "PaymentWaiverStatus",
  mixins: [hasNotifications],
  created() {
    this.loadData().finally(() => this.markSeen());
  },
  data: () => ({
    notifications: [],
    selectedNotification: null
  }),
  watch: {
    paymentComplete(val) {
      if (val) {
        this.selectedNotification.dismissStatus = "DISMISSED";
        put(
          userNotificationsByIdAPI.getUrl(this.selectedNotification.id),
          this.selectedNotification
        ).then(() => this.loadData());
      }
    }
  },
  methods: {
    loadData() {
      return get(userNotificationsAPI).then(response => {
        if (response && response.data) {
          this.notifications = response.data || [];
        }
      });
    },
    markSeen() {
      if (this.notifications && this.notifications.length) {
        for (let i = 0; i < this.notifications.length; i++) {
          const notification = this.notifications[i];
          notification.seen = true;
          notification.dismissStatus = "DISMISSED";

          put(userNotificationsByIdAPI.getUrl(notification.id), notification);
        }
      }
    },
    isNotApproved(notification) {
      return notification.notificationText.includes("not approved");
    },
    paymentFailed(notification) {
      return notification.notificationText.includes("unable to process");
    },
    icon(type) {
      switch (type) {
        case "INFO":
          return "$info";
        case "WARNING":
          return "$warning";
        case "SUCCESS":
          return "$valid";
        case "ERROR":
          return "$error";
      }
      return "mdi-firework";
    },
    redirectToPayForSubscription() {
      return "/account#subscriptions";
    }
  },
  computed: {
    // filter out the ones that are not approved and has been dismissed
    notifiables() {
      return this.notifications.filter(
        notification =>
          !this.isNotApproved(notification) ||
          notification.dismissStatus !== "DISMISSED"
      );
    }
  }
};
</script>

<style lang="sass" scoped>
.v-btn
  background-color: $color-pt-navy !important
  font-size: 16px
  height: 32px !important
.action
  min-width: 215px
</style>
